export default "__VITE_ASSET__xnVLo2B6__"